const thwiftyCM = [
  {
    link: "/search/sale",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNER5.jpg",
  },
  {
    link: "/search/beauty",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNER4.jpg",
  },
  {
    link: "/search/fashion",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNER1.jpg",
  },
  {
    link: "/search/sale",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNE2.jpg",
  },
  {
    link: "/search/sport",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNER3.jpg",
  },
];

const thwiftyCat_b = [
  {
    link: "Pet & Supplies",
    name: "Pet & Supplies",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536935841-PET-&--SUPPLIES.png",
  },
  {
    link: "gadget & Electronics",
    name: "gadget & Electronics",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536928687-GADGETS-&--ELECTRONICS-.png",
  },
  {
    link: "baby & Mom",
    name: "baby & Mom",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536906784-BABY&-MOM.png",
  },
  {
    link: "home & kitchen",
    name: "Home & Kitchen",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536853032-HOME-&--KITCHEN(1).png",
  },
  {
    link: "health personal care",
    name: "Health Personal Care",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536914553-HEALTH-&--PERSONAL-CARE-.png",
  },
  {
    link: "beauty & cosmetics",
    name: "Beauty & Cosmetics",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536869060-BEAUTY-&--COSMETICS.png",
  },
];

const thwiftyFashion = [
  {
    link: "baby and mom",
    name: "Baby & Mom",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431319457-Baby&Mom.jpg",
  },
  {
    link: "home and kitchen",
    name: "Home & Kitchen",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431373563-Home&Kitchen.jpg",
  },
  {
    link: "lifestyle and sports",
    name: "Lifestyle & Sports",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431406881-Lifestyle&Sports.jpg",
  },
  {
    link: "gadgets and electronics",
    name: "Gadgets & Electronics",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431438047-Gadgets&Electronics.jpg",
  },
  {
    link: "beauty and cosmetics",
    name: "Beauty & Cosmetics",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431468688-Beauty&Cosmetics.jpg",
  },
  {
    link: "health and personal care",
    name: "Health & Personal Care",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431498973-HealthPersonalCare.jpg",
  },
];

const HomeData = {
  category_b: thwiftyCat_b,
  fashion: thwiftyFashion,
  carousel: thwiftyCM,
};

export default HomeData;
